import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();


// WEBPACK FOOTER //
// ./src/_utils/history.js